export const EMAIL_THREAD_CREATED = 'EMAIL_THREAD_CREATED';
export const SEND_EMAIL_COMPOSITION_FAILED = 'SEND_EMAIL_COMPOSITION_FAILED';